import { render } from "./TransferVotes.vue?vue&type=template&id=69901898"
import script from "./TransferVotes.vue?vue&type=script&lang=js"
export * from "./TransferVotes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__